import { useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import "../Player/Level.css";
import { getcb } from "../../components/funtionsBD/Mainservice";
import { ExerciseTypeMark } from "../../components/ExerciseTypeMark";
import { competencyBlockIconSrc } from "../../utils/competencyBlockIcon";

const CBLevel = () => {
  const [open, setopen] = useState(false);
  const [success, setsuccess] = useState("");
  const [list, setlist] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getdata();
  }, []);

  const getdata = async () => {
    try {
      const response = await getcb();
      if (response.data.data.length > 0) {
        const data = response.data.data;
        setlist(data);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div id="adminRoot">
        <AddHeader title={t("competencyblock")} />
        <div className="level_div">
          <div className="input-detail">
            <p className="level_des">{t("levelmsg")} </p>
            {/* <input placeholder="A1" type="text" name="level" /> */}
          </div>
          {list.map((i, index) => (
            <div className="comp_level_card" key={index}>
              {competencyBlockIconSrc(i) ? (
                <ExerciseTypeMark src={competencyBlockIconSrc(i)} />
              ) : null}
              <div className="comp_level_info">
                <div className="comp_level_value">
                  <p>{i.cb_name_en}</p>
                  <p>{i.cb_score}</p>
                </div>
                <Slider
                  value={i.cb_score}
                  getAriaValueText={() => i.cb_score}
                  valueLabelDisplay="auto"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default CBLevel;
